import React from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { googleBucket, awsBucket } from "../constants/Constants.js"

const FormControlLabelPlacement = ({ value, setValue }) => {
    return (
        <div style={{ width: "100%", flexDirection: "column" }} className="flex" >
            <FormControl style={{ width: "90%" }}>
                <FormLabel id="demo-form-control-label-placement">Select Bucket type:</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    name="position"
                    defaultValue={value}
                    onChange={(e) => setValue(e.target.value)}
                >
                    {
                        awsBucket ?
                            <FormControlLabel
                                value="aws"
                                control={<Radio />}
                                label="AWS"
                                labelPlacement="aws"
                            />
                            : ""
                    }
                    {
                        googleBucket ?
                            <FormControlLabel
                                value="google"
                                control={<Radio />}
                                label="Google"
                                labelPlacement="Google"
                            />
                            :
                            ""
                    }
                    {/* <FormControlLabel
                        value="google"
                        control={<Radio />}
                        label="GOOGLE"
                        labelPlacement="google"
                    /> */}
                </RadioGroup>
            </FormControl>
        </div>
    )
}

export default FormControlLabelPlacement
